import * as Actions from "../../actions/app"

const initialState = {
  guide_types: null,
  departaments: null,
  provinces: null,
  districts: null,

  loading_electronic_guides: false,
  electronic_guides: null,
  total_electronic_guides: 0,

  loading_crud_electronic_guide: false,
  crud_electronic_guide: false,
}

const electronicGuide = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_GUIDE_TYPES: {
      return {
        ...state,
        guide_types: action.payload,
      }
    }

    case Actions.GET_DEPARTAMENTS: {
      return {
        ...state,
        departaments: action.payload,
      }
    }

    case Actions.GET_PROVINCES: {
      return {
        ...state,
        provinces: action.payload,
      }
    }

    case Actions.GET_DISTRICTS: {
      return {
        ...state,
        districts: action.payload,
      }
    }

    case Actions.GET_ELECTRONIC_GUIDES: {
      return {
        ...state,
        loading_electronic_guides: action.payload.loading,
        electronic_guides: typeof action.payload.detalles === 'undefined'
          ? state.electronic_guides
          : action.payload.detalles,
        total_electronic_guides: typeof action.payload.totalRegistros === 'undefined'
          ? state.total_electronic_guides
          : action.payload.totalRegistros,
      }
    }

    case Actions.SAVE_ELECTRONIC_GUIDE: {
      return {
        ...state,
        loading_crud_electronic_guide: action.payload.loading,
        crud_electronic_guide: action.payload.saved,
      }
    }

    default: {
      return state
    }
  }
}

export default electronicGuide
